import styled from 'styled-components';
import { colors } from '../../const/color';
import { font } from '../../const/font';
import { DropdownItemProps, DropdownLinkProps, DropdownMenuProps, DropdownToggleProps } from './types';

export const DropdownStyled = styled.div`
  margin: 0;
  padding: 0;
  position: relative;
  min-width: 100px;
`;

export const DropdownToggleStyled = styled.button<DropdownToggleProps>`
  width: fit-content;
  height: 32px;
  display: flex;
  align-items: center;
  gap: 18px;
  background: transparent;
  ${({ $color }) => $color && `color: ${colors[$color]}`};
  ${({ $borderColor }) => $borderColor && `border: 1px solid ${colors[$borderColor]}`};
  padding: 0;
  cursor: pointer;
  text-align: left;
  position: relative;
  font-size: ${font.size.sm}px;
  margin: auto;
  @media (hover: hover) {
    &:hover {
      border-bottom: 1px solid ${colors.primary};
    }
  }
`;

export const DropdownMenuStyled = styled.ul<DropdownMenuProps>`
  min-width: 100px;
  max-height: 340px;
  overflow-y: auto;
  position: absolute;
  background-color: ${colors.white};
  z-index: 3500;
  list-style: none;
  padding: 0;
  box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.4);
  top: 100%;
  left: 0;
  margin: 10px 0 0;
  display: ${({ active }) => (active ? 'block' : 'none')};
  &:before,
  &:after {
    position: absolute;
    content: '';
  }

  &:after {
    width: 0;
    height: 0;
    border-left: 6px solid transparent;
    border-right: 6px solid transparent;
    border-bottom: 6px solid ${colors.white};
    top: -6px;
    left: 10px;
    margin: 0 0 0 -3px;
    content: '';
    position: absolute;
    display: block;
    z-index: 11;
  }
`;

export const DropdownItemStyled = styled.li<DropdownItemProps>`
  border-bottom: 1px solid ${colors.grayMedium};
  &:nth-last-child(1) {
    border-bottom: none;
  }
`;

export const DropdownLinkStyled = styled.a<DropdownLinkProps>`
  color: ${colors.primary};
  position: relative;
  font-weight: 500;
  display: block;
  padding: 10px 15px;
  text-decoration: none;
  font-size: ${font.size.sm}px;
  cursor: pointer;

  &:hover,
  &:focus {
    color: ${colors?.primary};
  }

  &:hover {
    text-decoration: underline;
  }
`;
